@use 'sass:map';
@import '@helsenorge/designsystem-react/scss/spacers';
@import '@helsenorge/designsystem-react/scss/breakpoints';

.les-mer-list-wrapper {
  display: flex;
  flex-direction: column;
  row-gap: 0.46rem;
  margin-top: 3rem;

  @media (max-width: map.get($grid-breakpoints, md)) {
    margin-top: 2rem;
  }
}

.les-mer-list {
  list-style: none;
  width: inherit;
  padding: 0;
  margin: 0;

  &__list-item {
    display: flex;
    justify-content: space-between;
    position: relative;
    background: #ffefda12;
    width: 100%;
    padding: 1.68rem 2.18rem;
    text-decoration: none;
    flex-direction: column;

    @media (max-width: map.get($grid-breakpoints, md)) {
      padding: 1rem;
    }

    &--secondary {
      background: #ffefda1a;
    }

    &__icon {
      display: inline-flex;
      margin: 1rem 0;
      align-items: center;
      color: #ffdcb5;
      justify-content: space-between;
    }

    &:hover &__title,
    &:hover &__icon {
      text-decoration: underline;
    }

    &:focus-visible {
      outline: 2px solid #fff;
      outline-offset: -2px;
    }

    &__text {
      vertical-align: bottom;
      font-family: Avenir, Montserrat, Poppins, serif;
      font-size: 1.5rem;
      font-weight: 400;
      line-height: 2.25rem;
      text-align: left;
      color: #d5cfdc;
      text-decoration: none;
      word-break: break-word;
      margin-top: 0.187rem;

      @media (max-width: map.get($grid-breakpoints, md)) {
        font-size: 0.87rem;
        line-height: 1.3rem;
      }
    }

    &__video-icon {
      position: absolute;
      right: 2.18rem;
      top: 2.68rem;

      @media (max-width: map.get($grid-breakpoints, md)) {
        right: 1rem;
        top: 1rem;
      }
    }
  }
}
